import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m13.788 5.7-.122 7.085c-.039 2.222-1.871 4.054-4.093 4.093a3.86 3.86 0 0 1-3.954-3.975l.056-2.482m0 0 .013-.568m-.013.568.07-4.045a2.87 2.87 0 0 1 2.8-2.8 2.641 2.641 0 0 1 2.705 2.72l-.084 3.732m-5.491.393-.008.483m5.5-.876.006-.425m-.007.425-.05 2.861a1.55 1.55 0 0 1-1.51 1.512 1.426 1.426 0 0 1-1.462-1.46l.095-5.477" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);